export default {
	addAd: 'ADD_AD',
	error: 'ERROR_AD',
	loading: 'LOADING_AD',
};
